import React, { useState, useEffect } from 'react'
import Flatpickr from "react-flatpickr";
import Select from "react-select";

export default function InputModal({handleClose, saving, handleAddDate, balance }) {
    const [date, setDate] = useState(null)
    const [type, setType] = useState(null)
    let paymentOptions = [
        {id: 1, method: 'Cash'},
        {id: 2, method: 'Check'},
        {id: 3, method: "Offline Credit Card"}
    ]
    const [selectedPaymentType, setSelectedPaymentType] = useState(null)
    const [amount, setAmount] = useState(balance)

    // guard against paying more than the invoice
    useEffect(() => {
        if (amount > balance) {
            setAmount(balance)
            Alert.show('notice', 'Payment amount cannot be more than invoice amount')
        }
    }, [amount])

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                    <div>
                    <div class="row">
                        <div class="col-md-12">
                        <div class="form-group">
                            <label for="payment_date">Payment Date</label>
                            <Flatpickr
                                className="form-control"
                                value={date}
                                onChange={(date, dateStr) => {
                                setDate(dateStr)
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label>Payment Method</label>
                            <Select
                                className="form-control select-beneficiaries text-left"
                                classNamePrefix="select-beneficiaries"
                                onChange={(type) => setSelectedPaymentType(type)}
                                options={paymentOptions}
                                getOptionLabel={(type) =>
                                    `${type.method}`
                                }
                                getOptionValue={(type) => type.id}
                                value={selectedPaymentType}
                            />
                        </div>

                        <div className="form-group rd-pad-in">
                                <label htmlFor="invoice_number">Amount Paid</label>
                                <input
                                    className="form-control"
                                    placeholder="10.00"
                                    type="number"
                                    name="invoice_number"
                                    id="invoice_number"
                                    value={amount}
                                    onChange={(e) => {
                                    setAmount(e.target.value)
                                    }}
                                />
                                </div>
                        </div>
                    </div>
                    </div>
                    <div className="pt-3">
                        <button onClick={() => handleAddDate(date, selectedPaymentType, amount)} type="button" className="btn btn-primary mr-2" disabled={saving}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Add Payment
                        </button>

                        <button onClick={handleClose} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                            Cancel
                        </button>
                    </div>
                </div>
    </div>
    </div>
  )
}
